import { render, staticRenderFns } from "./TabAutorization.vue?vue&type=template&id=4758f7ea&"
import script from "./TabAutorization.vue?vue&type=script&lang=js&"
export * from "./TabAutorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports